import React from 'react';
import { Switch } from 'react-router-dom';
import AuthenticatedRoute from '../../components/AuthenticatedRoute/AuthenticatedRoute';
import { URLs } from '../../config/enums';
import { ResourcesEnum, PatentsEnum } from '../../api/roles/enums';
import Jobs from '../../components/Jobs/Jobs';

const JobsPage: React.FC = () => {
  return (
    <Switch>
      <AuthenticatedRoute path={URLs.JOBS} resource={ResourcesEnum.JOBS} patent={PatentsEnum.VIEW}>
        <Jobs />
      </AuthenticatedRoute>
    </Switch>
  );
};

export default JobsPage;
